export default __webpack_public_path__ + "static/media/adding_prospects.37768084.png";